module.exports = __webpack_public_path__ + "img/error_icon.6f37c077.svg";